// Animation configuration
export const ANIMATION_CONFIG = {
  DEFAULT_DURATION: 2.5,
  DEFAULT_REPEAT_DELAY: 0.8,
  INITIAL_DELAY: 500,
} as const;

// SkinnerBox specific configuration
export const SKINNER_BOX_CONFIG = {
  LEAVE_ANIM_DURATION_MS: 1000,
  LEAVE_ANIM_DELAY_MS: 500,
  SPIN_RANDOM_MIN: 1,
  SPIN_RANDOM_MAX: 2_000_000,
  FLYING_COINS_DELAY_IN: 0.05,
  FLYING_COINS_DURATION: 1.5,
  FLYING_COINS_REMOVE_IN: 4.4,
  SPARKLES_DURATION_MS_OUT: 1500,
  SPARKLES_DURATION_MS_IN: 500,
} as const;

// Animation states
export enum ANIMATION_STATE {
  IDLE = "idle",
  ANIMATING = "animating",
}

// SkinnerBox states
export enum SKINNER_BOX_STATE {
  IDLE = "idle",
  REVEAL = "reveal",
  CLAIMABLE = "claimable",
  CLAIMED = "claimed",
  LEAVE = "leave",
}

// Interaction states (for shine image, bonus text, etc.)
export enum INTERACTION_STATE {
  IDLE = "idle",
  CLICKED = "clicked",
  HIDDEN = "hidden",
}
